import { PATHWAYS_JSON_CONTENT_TYPE, sendHTTPRequest } from '@/util/http'
import { goalbookUrls } from '@/util/links'
import type { GoalHit } from '@/goals/goal_types'
import type { RelevantGoalsQuery } from '@/presentlevels/no-ai/goal_recommendations'

const GOALS_PER_QUERY = 3

// The response holds one list of goals per query, in the order the queries were sent.
export async function getRelevantGoalsForQueries(queries: RelevantGoalsQuery[]): Promise<GoalHit[][]> {
  try {
    const response = await sendHTTPRequest({
      url: `${goalbookUrls.pathwaysApi}/relevant_goals`,
      method: 'POST',
      contentType: PATHWAYS_JSON_CONTENT_TYPE,
      jsonBody: { queries, size: GOALS_PER_QUERY }
    })
    return await response.json() as GoalHit[][]
  } catch (error) {
    throw new Error('Failed to get relevant goals', { cause: error })
  }
}
